import { formatCertificateDate } from '@/utils/dateFormat';

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** Short relative time such as "just now", "5 min ago", "2 h ago", "3 d ago". */
export function formatNotificationTime(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) {
    return '';
  }

  const seconds = Math.max(0, Math.floor((now.getTime() - then.getTime()) / 1000));
  if (seconds < MINUTE) {
    return 'just now';
  }
  if (seconds < HOUR) {
    return `${Math.floor(seconds / MINUTE)} min ago`;
  }
  if (seconds < DAY) {
    return `${Math.floor(seconds / HOUR)} h ago`;
  }
  if (seconds < 7 * DAY) {
    return `${Math.floor(seconds / DAY)} d ago`;
  }

  return formatCertificateDate(iso);
}
